<template>
  <div>
    <BaseListPage
        :name="name"
        :no-condition="false"
        :base-query="baseQuery"
        :store-path="storePath"
        :response-path="responsePath"
        :save-key="saveKey"
        :is-parent-loaded="isParentLoaded"
        :table-set-list="tableSetList"
        :table-data-list="sortedList"
        title="保留条件：指定商品一覧"
        title-class="pendingproduct-header"
        icon="settings"
        table-class="row-clickable-table"
        @row-click="onRowClick">
      <span
          slot="headerAction"
          class="action_button">
        <el-dropdown
            v-show="$isFunctionShown(define.PermissionKeys.PendingProduct.List.NEW)"
            @command="actionCommand">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                v-if="$isFunctionShown(define.PermissionKeys.PendingProduct.List.NEW)"
                :disabled="$isFunctionDisabled(define.PermissionKeys.PendingProduct.List.NEW)"
                :command="define.PENDING_PRODUCT_MODE.NEW">
              新規登録
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </BaseListPage>
    <PendingProductBaseDialog
        width="70vw"
        class="pendingProductDialog"
        :title="getPendingProductTitle"
        :mode="mode"
        :disable-save-button="!isChanged"
        :show-only-close-button="false"
        :show-close="false"
        :before-close="beforeClose"
        :visible.sync="pendingProductDialogVisible"
        @ok="ok"
        @cancel="cancel"
        @close="close"
        @closed="closed"
        @regist="registList"
        @edit="editList"
        @delete="deleteList">
      <template
          slot="contents">
        <!-- 保留条件：指定商品詳細 -->
        <el-row>
          <el-col :span="24">
            <BaseTableDetail
                class="pending-product-item"
                :table-set-list="pendingProductInfo"
                :display-item="pendingProductData"
                :editable="editable" />
          </el-col>
        </el-row>
      </template>
    </PendingProductBaseDialog>
  </div>
</template>
<style scoped>

.pending-product-item ::v-deep table {
  width: 100%;
}
.pending-product-item ::v-deep th,
.pending-product-item ::v-deep td {
    padding: 5px 15px;
    font-size: 14px;
    text-align: left;
    vertical-align: top;
}
.pending-product-item ::v-deep th {
    width: 230px;
    padding-right: 0;
    height: 28px;
}
</style>

<script>
import _ from 'lodash'
import { mapState, mapMutations, mapGetters } from 'vuex'
import * as define from '@/define'
import * as query from '@/queries/pendingProduct'
import common from '@/utils/common'
import message from '@/utils/message'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import x from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import PendingProductBaseDialog from '@/components/pages/settings/PendingProductBaseDialog'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'

const EDITABLE = Object.freeze({
  [define.PENDING_PRODUCT_MODE.NORMAL]: Object.freeze({}),
  [define.PENDING_PRODUCT_MODE.DELETE]: Object.freeze({}),
  [define.PENDING_PRODUCT_MODE.CONFIRM]: Object.freeze({}),
  [define.PENDING_PRODUCT_MODE.EDIT]: Object.freeze({ site: true, status: true, name: true, startedAt: true, endedAt: true, note: true, pendingProductListItems: true }),
  [define.PENDING_PRODUCT_MODE.NEW]: Object.freeze({ site: true, status: true, name: true, startedAt: true, endedAt: true, note: true, pendingProductListItems: true })
})

export default {
  name: 'PendingProductList',
  components: {
    BaseListPage,
    BaseTableDetail,
    PendingProductBaseDialog
  },
  mixins: [x, confirmDiscardOnLeave],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      mode: define.PENDING_PRODUCT_MODE.NORMAL,
      pendingProductTitle: '',
      formatPendingProduct: {
        node: {
          id: '',
          uuid: undefined,
          site: {
            code: '',
            name: ''
          },
          status: '',
          name: '',
          startedAt: '',
          endedAt: '',
          note: '',
          pendingProductListItems: [],
          convertItems: '',
          createdAt: '',
          createdBy: '',
          updatedAt: '',
          updatedBy: ''
        }
      },
      originalData: {},
      localIsParentLoaded: false,
      pendingProductData: {},
      pendingProductDialogVisible: false,
      isChanged: false,
      beforeClose: null
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.PendingProduct.listIndex,
      tableSetList: (state) => state.PendingProduct.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'pendingProductList'
    },
    storePath () {
      return 'PendingProduct'
    },
    saveKey () {
      return 'pendingProductCondition'
    },
    responsePath () {
      return 'data.pendingProductList.edges'
    },
    returnPath () {
      return '/settings/pendingProduct'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_PENDING_PRODUCT_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        {
          type: 'String',
          label: '状態',
          path: 'node.status',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.STATUS,
          codeName: 'm_pending_product.status'
        },
        {
          type: 'String',
          label: '名称',
          path: 'node.name',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.NAME
        },
        {
          type: 'Date',
          label: '適用開始日時',
          path: 'node.startedAt',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.PERIOD
        },
        {
          type: 'Date',
          label: '適用終了日時',
          path: 'node.endedAt',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.PERIOD
        },
        {
          type: 'Date',
          label: '登録日時',
          path: 'node.createdAt',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.CREATED_AT
        },
        {
          type: 'Date',
          label: '更新日時',
          path: 'node.updatedAt',
          sortable: 'custom',
          funcId: define.PermissionKeys.PendingProduct.LIST && define.PermissionKeys.PendingProduct.List.UPDATED_AT
        }
      ]
    },
    pendingProductInfo () {
      return [
        {
          label: 'サイト',
          properties: [
            { path: 'node.site.code', type: 'String', editableId: 'site', elementType: ELEMENT_TYPE.SELECT_BOX,
              validateRule: 'required', validateAs: 'サイト', funcId: define.PermissionKeys.PendingProduct.List.SITE,
              selectCode: 'sites', codeName: 'sites'
            }
          ]
        },
        {
          label: '状態',
          properties: [
            { path: 'node.status', type: 'Number', editableId: 'status', elementType: ELEMENT_TYPE.SELECT_BOX,
              validateRule: 'required', validateAs: '状態', funcId: define.PermissionKeys.PendingProduct.List.STATUS,
              selectCode: 'm_pending_product.status', codeName: 'm_pending_product.status'
            }
          ]
        },
        {
          label: '名称',
          properties: [
            { path: 'node.name', type: 'String', editableId: 'name', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:256', validateAs: '名称', funcId: define.PermissionKeys.PendingProduct.List.NAME
            }
          ]
        },
        {
          label: '適用開始日時',
          properties: [
            { path: 'node.startedAt', type: 'Date', editableId: 'startedAt', elementType: ELEMENT_TYPE.DATE_TIME,
              validateRule: 'required', validateAs: '適用開始日時', funcId: define.PermissionKeys.PendingProduct.List.PERIOD
            }
          ]
        },
        {
          label: '適用終了日時',
          properties: [
            { path: 'node.endedAt', type: 'Date', editableId: 'endedAt', elementType: ELEMENT_TYPE.DATE_TIME,
              validateRule: 'required', validateAs: '適用終了日時', funcId: define.PermissionKeys.PendingProduct.List.PERIOD
            }
          ]
        },
        {
          label: '管理用メモ',
          properties: [
            { path: 'node.note', type: 'String', editableId: 'note', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA,
              validateRule: 'max:256', validateAs: '管理用メモ', funcId: define.PermissionKeys.PendingProduct.List.NOTE
            }
          ]
        },
        {
          label: '指定商品',
          properties: [
            { path: 'node.convertItems', type: 'String', editableId: 'pendingProductListItems', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA,
              validateRule: 'required', validateAs: '指定商品', funcId: define.PermissionKeys.PendingProduct.List.ITEM
            }
          ]
        },
        {
          label: '登録日時',
          properties: [
            { path: 'node.createdAt', type: 'Date', editableId: 'createdAt', elementType: ELEMENT_TYPE.DATE,
              validateRule: 'required', validateAs: '登録日時', funcId: define.PermissionKeys.PendingProduct.List.CREATED_AT,
              isShow: () => (this.mode !== define.PENDING_PRODUCT_MODE.NEW)
            }
          ]
        },
        {
          label: '登録者',
          properties: [
            { path: 'node.createdBy', type: 'String', editableId: 'createdBy', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required', validateAs: '登録者', funcId: define.PermissionKeys.PendingProduct.List.CREATED_BY,
              isShow: () => (this.mode !== define.PENDING_PRODUCT_MODE.NEW)
            }
          ]
        },
        {
          label: '更新日時',
          properties: [
            { path: 'node.updatedAt', type: 'Date', editableId: 'updatedAt', elementType: ELEMENT_TYPE.DATE_TIME,
              validateRule: 'required', validateAs: '更新日時', funcId: define.PermissionKeys.PendingProduct.List.UPDATED_AT,
              isShow: () => (this.mode !== define.PENDING_PRODUCT_MODE.NEW)
            }
          ]
        },
        {
          label: '更新者',
          properties: [
            { path: 'node.updatedBy', type: 'String', editableId: 'updatedBy', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required', validateAs: '更新者', funcId: define.PermissionKeys.PendingProduct.List.UPDATED_BY,
              isShow: () => (this.mode !== define.PENDING_PRODUCT_MODE.NEW)
            }
          ]
        }
      ]
    },
    getPendingProductTitle () {
      return this.pendingProductTitle
    },
    editable () {
      return EDITABLE[this.mode]
    },
    editableAddrs () {
      return this.mode === define.PENDING_PRODUCT_MODE.NEW || this.mode === define.PENDING_PRODUCT_MODE.EDIT
    },
    isParentLoaded () {
      return this.localIsParentLoaded
    }
  },
  watch: {
    pendingProductData: {
      handler: function (val, oldVal) {
        let vm = this
        vm.isChanged = true
      },
      deep: true
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      this.$store.dispatch({
        type: 'set',
        states: {
          'PendingProduct/tableSetList': this._tableSetList
        }
      })
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.beforeClose = () => {
        switch (this.mode) {
          case define.PENDING_PRODUCT_MODE.NORMAL:
            this.ok()
            break
          case define.PENDING_PRODUCT_MODE.NEW:
          case define.PENDING_PRODUCT_MODE.EDIT:
            this.cancel()
            break
          case define.PENDING_PRODUCT_MODE.CONFIRM:
          case define.PENDING_PRODUCT_MODE.DELETE:
          default:
            break
        }
      }
    })
  },
  methods: {
    ...mapMutations('PendingProduct', {
      updateListItem: 'update',
      deleteListItem: 'delete'
    }),
    onRowClick (row, column, event) {
      // 詳細表示
      this.pendingProductTitle = '保留条件：指定商品詳細'
      this.pendingProductDialogVisible = true
      this.originalData = row
      const convertItems = this.convertDispPendingProductItems(row)
      this.originalData.node.convertItems = convertItems
      this.pendingProductData = _.cloneDeep(this.originalData)
    },
    convertDispPendingProductItems (row) {
      return _.chain(row.node.pendingProductListItems)
        .map('productId')
        .sort()
        .join('\n')
        .value()
    },
    convertParamPendingProductItems (row) {
      return _.chain(row.node.convertItems)
        .split('\n')
        .filter(val => _.trim(val) !== '')
        .sort()
        .value()
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.PENDING_PRODUCT_MODE.NEW:
          this.pendingProductTitle = '保留条件：指定商品登録'
          this.pendingProductData = _.cloneDeep(this.formatPendingProduct)
          this.pendingProductDialogVisible = true
          this.mode = define.PENDING_PRODUCT_MODE.NEW
          break
        default:
          break
      }
    },
    ok () {
      if (this.mode !== define.PENDING_PRODUCT_MODE.CONFIRM) {
        this.pendingProductDialogVisible = false
      }
    },
    close () {
      this.beforeClose()
    },
    closed () {
      this.mode = define.PENDING_PRODUCT_MODE.NORMAL
    },
    cancel () {
      const cancelEdit = () => {
        if (this.mode === define.PENDING_PRODUCT_MODE.NEW) {
          this.pendingProductDialogVisible = false
        } else {
          this.pendingProductTitle = '保留条件：指定商品詳細'
        }
        this.mode = define.PENDING_PRODUCT_MODE.NORMAL
      }
      // 変更があった場合は確認ダイアログを表示
      if (this.isChanged) {
        this.$confirm(
          this.mode === define.PENDING_PRODUCT_MODE.NEW
            ? '登録を中止しますか？'
            : '変更を破棄しますか？',
          define.MESSAGE_TITLE,
          {
            confirmButtonText: 'はい',
            cancelButtonText: 'いいえ',
            type: 'warning'
          }
        ).then(() => {
          cancelEdit()
          this.pendingProductData = _.cloneDeep(this.originalData)
        }).catch(() => {})
      } else {
        cancelEdit()
      }
    },
    registList () {
      if (this.mode === define.PENDING_PRODUCT_MODE.NEW) {
        this.$validator.validate().then(result => {
          if (result) {
            this.$confirm(
              '保存しますか？',
              define.MESSAGE_TITLE,
              {
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                type: 'warning'
              }
            ).then(() => {
              // 登録・更新API呼び出し
              this.updateOrInsertPendingProduct()
            }).catch(() => {})
          }
        })
      } else if (this.mode === define.PENDING_PRODUCT_MODE.EDIT) {
        this.$validator.validate().then(result => {
          if (result) {
            this.$confirm(
              '保存しますか？',
              define.MESSAGE_TITLE,
              {
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                type: 'warning'
              }
            ).then(() => {
              // 登録・更新API呼び出し
              this.updateOrInsertPendingProduct()
              this.ok()
            }).catch(() => {})
          }
        })
      }
    },
    editList () {
      this.pendingProductTitle = '保留条件：指定商品編集'
      this.mode = define.PENDING_PRODUCT_MODE.EDIT
      this.isChanged = false
    },
    deleteList () {
      this.$confirm(
        '削除します。よろしいですか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // 保留条件指定商品削除処理（APIコール）
        this.deletePendingProduct()
      }).catch(() => {})
    },
    /**
     * pendingProductData から保留条件指定商品登録APIのリクエストパラメータを作成する.
     */
    buildRequestForInsert () {
      // 指定商品のデータ形式変換処理
      const items = this.convertParamPendingProductItems(this.pendingProductData)
      for (const i in items) {
        const pendingProductItems = {}
        pendingProductItems.productId = items[i]
        this.pendingProductData.node.pendingProductListItems[i] = pendingProductItems
      }
      // パラメータ設定処理
      const pendingProduct = {
        siteCode: this.pendingProductData.node.site.code,
        status: this.pendingProductData.node.status,
        name: this.pendingProductData.node.name,
        startedAt: this.pendingProductData.node.startedAt,
        endedAt: this.pendingProductData.node.endedAt,
        note: this.pendingProductData.node.note,
        delete: 0
      }
      let requestBody = {}
      requestBody.pendingProduct = pendingProduct
      requestBody.pendingProductItems = this.pendingProductData.node.pendingProductListItems
      // console.log('buildRequestForInsert requestBody', requestBody)
      return requestBody
    },
    /**
     * pendingProductData から保留条件指定商品更新APIのリクエストパラメータを作成する.
     * originalDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      const diff = compare.diff(this.originalData.node, this.pendingProductData.node)
      let pendingProductItems = []
      const convertItems = diff.convertItems ? diff.convertItems : ''
      if (convertItems !== '') {
        // 指定商品のデータ形式変換処理
        const items = this.convertParamPendingProductItems(this.pendingProductData)
        for (const i in items) {
          const pendingProductItem = {}
          pendingProductItem.productId = items[i]
          pendingProductItems[i] = pendingProductItem
        }
      }
      let requestBody = {}
      requestBody.pendingProduct = {}
      requestBody.pendingProduct = _.pick(diff, ['site.code', 'status', 'name', 'startedAt', 'endedAt', 'note'])
      requestBody.pendingProduct.id = this.pendingProductData.node.id
      requestBody.pendingProduct.delete = 0
      requestBody.pendingProductItems = pendingProductItems
      // console.log('buildRequestForUpdate requestBody', requestBody)
      return requestBody
    },
    /**
     * pendingProductData から保留条件指定商品削除APIのリクエストパラメータを作成する.
     */
    buildRequestForDelete () {
      let requestBody = {}
      requestBody.pendingProduct = {}
      requestBody.pendingProduct.id = this.pendingProductData.node.id
      requestBody.pendingProduct.delete = 1
      requestBody.pendingProductItems = []
      // console.log('buildRequestForUpdate requestBody', requestBody)
      return requestBody
    },
    async updateOrInsertPendingProduct () {
      try {
        this.$loadingService.show()
        await this.updateOrInsertPendingProductApi()
        this.isChanged = false
        if (this.mode === define.PENDING_PRODUCT_MODE.CONFIRM) {
          this.$alert(
            '更新しました。',
            define.MESSAGE_TITLE,
            { type: 'warning', showClose: false }
          )
        }
        this.$notify.success('保存しました。')
        this.mode = define.PENDING_PRODUCT_MODE.NORMAL
        this.pendingProductDialogVisible = false
        this.refreshList()
      } catch (error) {
        const data = _.get(error, 'response.data')
        if (data == null) {
          common.addError(error, { msg: message.MSG_502() })
        } else {
          if (this.hasNotExistSKUError(error)) {
            common.addError(error, { msg: message.MSG_571() })
          } else if (this.hasDuplicateSKUError(error)) {
            common.addError(error, { msg: message.MSG_572() })
          } else if (this.mode === define.PENDING_PRODUCT_MODE.NEW) {
            common.addError(error, { msg: message.MSG_568() })
          } else {
            common.addError(error, { msg: message.MSG_569() })
          }
        }
        this.$notify.error({ error: error })
      } finally {
        this.$loadingService.close()
      }
    },
    async deletePendingProduct () {
      try {
        this.$loadingService.show()
        await this.deletePendingProductApi()
        this.deleteListItem(this.pendingProductData.node.uuid)
        this.$notify.success('削除しました。')
        this.pendingProductDialogVisible = false
        this.mode = define.PENDING_PRODUCT_MODE.NORMAL
        this.isChanged = false
        this.refreshList()
      } catch (error) {
        const data = _.get(error, 'response.data')
        if (data == null) {
          common.addError(error, { msg: message.MSG_502() })
        } else {
          common.addError(error, { msg: message.MSG_570() })
        }
        this.$notify.error({ error: error })
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 保留条件指定商品更新 APIを呼び出す
     */
    async updateOrInsertPendingProductApi () {
      let url
      let method
      let data
      let heads = {}
      if (this.mode === define.PENDING_PRODUCT_MODE.NEW) {
        url = config.PENDING_PRODUCT_URL
        method = 'post'
        data = this.buildRequestForInsert()
      } else {
        heads = { 'X-CCS-Last-Updated-At': this.pendingProductData.node.updatedAt }
        url = config.PENDING_PRODUCT_URL
        method = 'post'
        data = this.buildRequestForUpdate()
      }
      // console.log('updateOrInsertPendingProductApi heads', heads)
      // console.log('updateOrInsertPendingProductApi url', url)
      // console.log('updateOrInsertPendingProductApi method', method)
      // console.log('updateOrInsertPendingProductApi data', data)
      const response = await common.apiAxios(url, { method, data, heads })
      return response
    },
    async deletePendingProductApi () {
      const heads = { 'X-CCS-Last-Updated-At': this.pendingProductData.node.updatedAt }
      const url = config.PENDING_PRODUCT_URL
      const method = 'post'
      const data = this.buildRequestForDelete()
      // console.log('deletePendingProductApi heads', heads)
      // console.log('deletePendingProductApi url', url)
      // console.log('deletePendingProductApi method', method)
      // console.log('deletePendingProductApi data', data)
      const response = await common.apiAxios(url, { method, data, heads })
      return response
    },
    async refreshList () {
      try {
        const tdLists = this.storePath + '/tdLists'
        let queryCondition = this.searchConditions(this.storePath)
        const aquery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_PENDING_PRODUCT_LIST, queryCondition)
        const res = await common.postGraphQl(aquery)
        this.$store.dispatch({
          type: 'set',
          states: {
            [tdLists]: common.getValueByPath(res.data, this.responsePath)
          }
        })
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      }
    },
    hasNotExistSKUError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }
      return _.get(error, 'response.data.reason', '') === 'invalidParameter not exist SKU code'
    },
    hasDuplicateSKUError (error) {
      const code = _.get(error, 'response.data.code')
      if (code !== 400) {
        return false
      }
      return _.get(error, 'response.data.reason', '') === 'invalidParameter duplicate SKU code'
    }
  }
}
</script>
